import { render, staticRenderFns } from "./green-energy.vue?vue&type=template&id=05a7845b&"
import script from "./green-energy.vue?vue&type=script&lang=js&"
export * from "./green-energy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports